// Badge visual para estado_workflow segun ADR-007 + Δ3.
// Muestra color/icono por estado y, opcionalmente, un tag adicional cuando
// la transicion vino de auto-aprobacion (Δ3 — solo 1 nutricionista activa).
import { clsx } from 'clsx'

export type EstadoWorkflowLike = string

interface WorkflowBadgeProps {
  estado: EstadoWorkflowLike
  autoAprobado?: boolean
  className?: string
}

const ESTADO_COLOR: Record<string, string> = {
  BORRADOR: 'bg-gray-200 text-gray-800',
  EN_REVISION: 'bg-orange-200 text-orange-900',
  PENDIENTE: 'bg-orange-200 text-orange-900',
  PENDIENTE_APROBACION: 'bg-orange-200 text-orange-900',
  APROBADO: 'bg-green-200 text-green-900',
  VERIFICADO_CHEF: 'bg-emerald-300 text-emerald-900',
  BLOQUEADO: 'bg-red-200 text-red-900',
}

export default function WorkflowBadge({
  estado,
  autoAprobado = false,
  className,
}: WorkflowBadgeProps) {
  const upper = String(estado || 'BORRADOR').toUpperCase()
  const color = ESTADO_COLOR[upper] ?? 'bg-gray-200 text-gray-800'
  return (
    <span className={clsx('inline-flex items-center gap-1', className)}>
      <span
        data-testid="workflow-badge"
        data-estado={upper}
        className={clsx(
          'text-xs px-2 py-0.5 rounded font-semibold uppercase tracking-wide',
          color,
        )}
        aria-label={`Estado: ${upper}`}
      >
        {upper}
      </span>
      {autoAprobado && (
        <span
          data-testid="auto-aprobado-flag"
          className="text-xs px-2 py-0.5 rounded font-semibold bg-yellow-100 text-yellow-900 border border-yellow-300"
          title="Aprobado automaticamente — solo 1 nutricionista activa (Δ3)"
          aria-label="auto aprobado"
        >
          AUTO-APROBADO
        </span>
      )}
    </span>
  )
}
